import { render, staticRenderFns } from "./FAQActivitiesTimelineItem.vue?vue&type=template&id=3ba7d85e"
import script from "./FAQActivitiesTimelineItem.vue?vue&type=script&lang=js"
export * from "./FAQActivitiesTimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports